module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "otherBox"
  }, [_c('el-form', {
    ref: "otnerform",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位全称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "单位全称"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位地址",
      "prop": "address"
    }
  }, [_c('dataTree', {
    attrs: {
      "defaultData": _vm.defaultPointerData
    },
    on: {
      "change": _vm.changeId
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "400px",
      "display": "block",
      "margin-top": "22px"
    },
    attrs: {
      "placeholder": "街道详细地址"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人",
      "label-width": "120px",
      "prop": "linkMan"
    }
  }, [_c('el-input', {
    staticClass: "input-w180",
    attrs: {
      "placeholder": "联系人"
    },
    model: {
      value: (_vm.form.linkMan),
      callback: function($$v) {
        _vm.$set(_vm.form, "linkMan", $$v)
      },
      expression: "form.linkMan"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "label-width": "120px",
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticClass: "input-w180",
    attrs: {
      "placeholder": "联系电话"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "中心坐标",
      "label-width": "120px",
      "prop": "latitude"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showMap.state = true
      }
    }
  }, [_vm._v("地图选点")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.form.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.form.latitude)))]), _vm._v(" "), _c('mapPointer', {
    attrs: {
      "show": _vm.showMap,
      "source": {
        lat: _vm.form.latitude,
        lng: _vm.form.longitude
      }
    },
    on: {
      "change": _vm.confirm
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属区划",
      "prop": "regions",
      "label-width": "120px"
    }
  }, [_c('dataTreeboth', {
    attrs: {
      "defaultDataval": _vm.defaultPointerDataval
    },
    on: {
      "change": _vm.changeRegion
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95b652e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plan/Govform.vue
// module id = 1268
// module chunks = 2